import { deserialize } from 'libs/cerialize';

export class AutolinkModel {
	@deserialize
	LeftEntityId: number;

	@deserialize
	RightEntityId: number;
}